/**
 *
 * Component: Steps
 * Date: 22/1/2021
 *
 */

import React from 'react';

import { Steps as CustomSteps } from 'antd';
import styles from './style.module.css';
import { StepsInterface } from './interfaces';

const { Step } = CustomSteps;
function Steps({ current, steps }: StepsInterface) {
  return (
    <div className={styles.container}>
      <CustomSteps current={current}>
        {steps.map((step) => (
          <Step key={step.title} status={step.status} title={step.title} />
        ))}
      </CustomSteps>
    </div>
  );
}

export default Steps;
